import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/public/Home.vue'
import auth from './helpers/auth'

Vue.use(Router)

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'home' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkExactActiveClass: 'exact-active',
	linkActiveClass: 'active',
	routes: [{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/panduan',
		name: 'panduan',
		component: () =>
		import ('./views/public/Panduan.vue')
	},
	{
		path: '/mobile-counter/:code',
		name: 'stockist',
		component: () =>
		import ('./views/public/Stockist.vue')
	},
	{
		path: '/product/:code',
		name: 'product',
		component: () =>
		import ('./views/public/Product.vue')
	},
	{
		path: '/products',
		name: 'products',
		component: () =>
		import ('./views/public/AllProduct.vue')
	},
	{
		beforeEnter: isUnauth,
		path: '/cek-transaksi',
		name: 'cek-transaksi',
		component: () =>
		import ('./views/public/CheckTransaction.vue')
	},
	{
		path: '/cart',
		name: 'cart',
		component: () =>
		import ('./views/public/Cart.vue')
	},
	{
		path: '/shipping',
		name: 'shipping',
		component: () =>
		import ('./views/public/ShippingMethod.vue')
	},
	{
		path: '/payment',
		name: 'payment',
		component: () =>
		import ('./views/public/PaymentMethod.vue')
	},
	{
		path: '/about',
		name: 'about',
		component: () =>
		import ('./views/About.vue')
	},
	{
		beforeEnter: isAuth,
		path: '/transaction',
		name: 'transaction',
		component: () =>
		import ('./views/member/Transaction.vue')
	},
	{
		beforeEnter: isAuth,
		path: '/transaction/:code',
		name: 'transactionDetail',
		component: () =>
		import ('./views/member/StatusTransaksi.vue')
	},
	{
		beforeEnter: isAuth,
		path: '/address',
		name: 'address',
		component: () =>
		import ('./views/member/Address.vue')
	},
	{
		beforeEnter: isAuth,
		path: '/bank',
		name: 'bank',
		component: () =>
		import ('./views/member/Bank.vue')
	},
	{
		beforeEnter: isUnauth,
		path: '/login',
		name: 'login',
		component: () =>
		import ('./views/Login.vue')
	},
	{
		beforeEnter: isAuth,
		path: '/member',
		name: 'member',
		component: () =>
		import ('./views/About.vue')
	},
	// {
	// 	beforeEnter: isUnauth,
	// 	path: '/maps-marker',
	// 	name: 'maps-marker',
	// 	component: () =>
	// 	import ('./views/maps-marker.vue')
	// },
	{
		path: '*',
		beforeEnter: (to, from, next) => {
			next('/')
		}
	}
	],
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition;
		}

		return { x: 0, y: 0 };
	},
})